var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('Icon',{attrs:{"size":"xs","item":_vm.item}}),_c('div',{staticClass:"amount",class:_vm.positiveOrNegative(_vm.amount)},[_vm._v(_vm._s(_vm.formatAmount(_vm.amount)))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/pablo/vortex/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27606c15","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/pablo/vortex/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!/home/pablo/vortex/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buildings/common/Counter.vue
// module id = null
// module chunks = 